{
	"termsAndConditions": {
		"title": "Όροι & Προϋποθέσεις",
		"submitTitle": "Αποδοχή & Συνέχιση της Πολιτικής Απορρήτου"
	},
	"privacyPolicy": {
		"title": "Πολιτική Απορρήτου",
		"submitTitle": "Αποδοχή & Κλείσιμο",
		"backTitle": "Πίσω"
	}
}
